import { render, staticRenderFns } from "./BottomNavigator.vue?vue&type=template&id=33a5b58b"
import script from "./BottomNavigator.vue?vue&type=script&lang=js"
export * from "./BottomNavigator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports